import { type LocationV2ApiModel } from '@webapp/core/data-access/api-models/LocationV2ApiModel'
import { type DetailedPrimaryCategoryConstructor } from '@webapp/core/entities/internal/DetailedPrimaryCategory'

export const mapLocationV2 = (
  locationV2: LocationV2ApiModel
): DetailedPrimaryCategoryConstructor => ({
  id: locationV2.id,
  name: locationV2.name,
  isHeadquarter: locationV2.headquarter,
  primaryShippingAddress: mapLocationV2ShippingAddress(
    locationV2.primary_shipping_address,
    locationV2.active
  ),
})

const mapLocationV2ShippingAddress = (
  shippingAddress: LocationV2ApiModel['primary_shipping_address'],
  isActive: boolean
): DetailedPrimaryCategoryConstructor['primaryShippingAddress'] => ({
  id: shippingAddress.id,
  name: shippingAddress.name,
  isActive,
  addressLineOne: shippingAddress.addressLineOne,
  city: shippingAddress.city,
  stateProvince: shippingAddress.state_province,
  country: shippingAddress.country,
  postalCode: shippingAddress.postalCode,
})
